export default __webpack_public_path__ + "static/media/hero.8f7957e4.png";